import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { questionService, examService } from '../services/api';
import './Home.css';

function Home() {
  const navigate = useNavigate();
  const [questionCount, setQuestionCount] = useState(0);
  const [completedExams, setCompletedExams] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      const count = await questionService.countQuestions();
      const exams = await examService.getCompletedExams();
      setQuestionCount(count);
      setCompletedExams(exams);
    } catch (error) {
      console.error('Erro ao carregar dados:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading">
        <div>
          <div className="spinner"></div>
          <p>Carregando...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="home-container">
      <div className="container">
        {/* Header */}
        <div className="home-header">
          <h1>🎓 Sistema de Certificação SAP</h1>
          <p className="subtitle">SAP Commerce Cloud - P_C4H34_2411</p>
        </div>

        {/* Info Cards */}
        <div className="info-grid">
          <div className="info-card">
            <div className="info-icon">📚</div>
            <div className="info-content">
              <h3>{questionCount}</h3>
              <p>Questões Disponíveis</p>
            </div>
          </div>

          <div className="info-card">
            <div className="info-icon">⏱️</div>
            <div className="info-content">
              <h3>180 min</h3>
              <p>Duração da Prova</p>
            </div>
          </div>

          <div className="info-card">
            <div className="info-icon">🎯</div>
            <div className="info-content">
              <h3>61%</h3>
              <p>Para Aprovação</p>
            </div>
          </div>

          <div className="info-card">
            <div className="info-icon">✅</div>
            <div className="info-content">
              <h3>{completedExams.length}</h3>
              <p>Simulados Realizados</p>
            </div>
          </div>
        </div>

        {/* Main Actions */}
        <div className="card main-actions">
          <h2 className="text-center">Escolha uma Opção</h2>

          <div className="action-buttons">
            <button
              className="action-btn"
              onClick={() => navigate('/config')}
            >
              <div className="action-icon">🚀</div>
              <h3>Novo Simulado</h3>
              <p>Iniciar um novo simulado de certificação</p>
            </button>
          </div>
        </div>

        {/* Recent Exams */}
        {completedExams.length > 0 && (
          <div className="card">
            <h2>Últimos Simulados</h2>
            <div className="recent-exams">
              {completedExams.slice(0, 5).map(exam => (
                <div key={exam.id} className="exam-item">
                  <div className="exam-info">
                    <h4>{exam.title}</h4>
                    <p>
                      {new Date(exam.completedAt).toLocaleDateString('pt-BR')} -
                      Pontuação: {exam.score}%
                    </p>
                  </div>
                  <div className={`exam-badge ${exam.passed ? 'passed' : 'failed'}`}>
                    {exam.passed ? '✅ Aprovado' : '❌ Reprovado'}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Footer Info */}
        <div className="footer-info">
          <p>💡 Dica: Pratique regularmente para melhorar seu desempenho!</p>
        </div>
      </div>
    </div>
  );
}

export default Home;
